'use client';

import React, { useState } from 'react';
import { useModals } from '~/contexts/ModalsContext';
import ReportIcon from '~/public/static/svg/ReportIcon';
import { RailsItem } from '~/typings/services/rails/item';

interface Props {
  item: RailsItem;
}

const ReportItemButton: React.FC<Props> = ({ item }) => {
  const modals = useModals();
  const [reported, setReported] = useState(false);
  return (
    <div>
      {reported ? (
        <div className="text-right text-sm font-semibold leading-tight">
          Reported
        </div>
      ) : (
        <button
          className="text-slate-green-500 ml-auto flex items-center space-x-1 text-sm"
          onClick={() =>
            modals.openModal('removeReport', {
              item,
              onSuccessfulSubmit: () => setReported(true),
              type: 'reportItem',
            })
          }
        >
          <ReportIcon />
          <span>Report</span>
        </button>
      )}
    </div>
  );
};

export default ReportItemButton;
